export const UNKNOWN = 'UNKNOWN';
export const AUTOPAY = 'AUTOPAY';
export const MANUAL = 'MANUAL';
export const CHECKING = 'CHECKING';
export const SAVINGS = 'SAVINGS';

export const ACCOUNT_TYPE = [
  {
    value: CHECKING,
    label: 'Checking',
  },
  {
    value: SAVINGS,
    label: 'Savings',
  },
];
